import React from 'react';
import { Outlet } from 'react-router-dom';
import { RiderBottomNav } from './components/RiderBottomNav';

export const RiderLayout: React.FC = () => {
    return (
        <div className="repaart-shell flex h-[100dvh] w-full flex-col overflow-hidden text-slate-900 selection:bg-ruby-500/20 dark:text-slate-100">
            {/* Safe Area Top Spacer */}
            <div className="app-safe-header h-safe sticky top-0 z-40 w-full" />

            {/* Main Content Area - Scrollable */}
            <main className="flex-1 min-h-0 relative overflow-y-auto overflow-x-hidden hide-scrollbar z-10">
                <div className="max-w-md mx-auto w-full min-h-full px-0">
                    <div className="pb-24 mb-safe">
                        <Outlet />
                    </div>
                </div>
            </main>

            <RiderBottomNav />
        </div>
    );
};
